"use client";

import { UploadPaperFromURL } from "@/components/papers/UploadPaperFromURL";
import { UploadPlugin } from "./plugin-interface";
import { getUploadMessages } from "../locales/messages";

const messages = getUploadMessages();

export const urlPlugin: UploadPlugin = {
  id: "url",
  name: messages.buttons.urlUpload,
  source: "url",
  renderTrigger: ({ onUpload }) => (
    <UploadPaperFromURL onFileFetched={onUpload} />
  ),
};

